import React from "react";

interface EventCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  titleClassName?: string;
  centerContent?: boolean;
}

const EventCard: React.FC<EventCardProps> = ({
  title,
  children,
  className,
  titleClassName,
  centerContent,
}) => (
  <div
    className={`bg-black/50 backdrop-blur-md rounded-2xl p-6 border border-white/20 ${centerContent ? "flex flex-col items-center" : ""} ${className}`}
  >
    <h3
      className={`text-3xl text-white font-nostalgic mb-4 text-center ${titleClassName}`}
    >
      {title}
    </h3>
    {children}
  </div>
);

EventCard.defaultProps = {
  className: "",
  titleClassName: "",
  centerContent: false,
};

export default EventCard;
